import { render, staticRenderFns } from "./BgColumn.vue?vue&type=template&id=6d52ce13"
import script from "./BgColumn.vue?vue&type=script&lang=js"
export * from "./BgColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports